import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'managersRemoveFromTag'

export default (managerIds, tagId) => (asyncAction(
  name,
  ManagersService.managersRemoveFromTag,
  { managerIds, tagId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/managersRemoveFromTag.js